export default __webpack_public_path__ + "static/media/google-logo.7e2e80ea.png";